import React, { useContext, useEffect, useState } from "react";
import {
  SideMenuItems,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import { AppContext } from "../../Contexts/AppContextProvider";
import {hyperlinkTextMDEs } from "../../Helpers/HelperText";
import {
  applySidebarState,
  toggleSidebar,
} from "../../Helpers/Utilities";
import InfoPopUp from "../../Components/InfoPopUp";

const MDEInfoPage = () => {
  const navigatePaths = {
    prevPage: "/TransplantCharacteristics",
    currPage: "/MDEInfo",
    nextPage: "/MDESForm",
  };

  const {
    isSideMenuActive,
    setisSideMenuActive,
  } = useContext(AppContext);


  const [showHideHyperlinkModalS2, setShowHideHyperlinkModalS2] = useState(false);

  const SaveForm = async () => {
    return true;
  };

  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div>
          <SideBarMenu activePageId={SideMenuItems.MDEInfoPage} />
          <button
            className={isSideMenuActive ? "openbtn" : "openbtn active"}
            onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
          >
            <i
              id="arrowNavigation"
              className="fa fa-arrow-left"
              aria-hidden="true"
            ></i>
          </button>

          <div className="col-pad-left" id="main">
            <div className="survey-section-content" id="contentsec">
              <div className="survey-section-content-header">
                <h4>
                 ** METABOLIC DECOMPENSATION EVENTS (MDEs)</h4>
              </div>

              <div className="survey-introduction-section">
                <div className="survey-introduction-content survey-content-box">
                  <div className="instructions">
                    <div>
                      The following section will collect information on patient’s{" "}
                      <span
                        data-tooltip-id="encounterTip"
                        className="modal-popup"
                        onClick={() => setShowHideHyperlinkModalS2(true)}
                      >
                        metabolic decompensation events (MDEs)
                      </span>{" "}
                      {showHideHyperlinkModalS2 && (
                        <InfoPopUp
                          description={hyperlinkTextMDEs}
                          OkClick={() => setShowHideHyperlinkModalS2(false)}
                        />
                      )}{" "}
                      or metabolic crises within 12 months prior to and within 27 months
                      on and after the index date.
                      <br />
                      <br />
                      We encourage sites to use their own criteria for defining MDEs.
                      If your site does not have specific criteria for defining an MDE,
                      please abstract MDEs using the following guidance below (and hyperlinked throughout) where
                      MDEs are identified as having both the following:
                      <p className="margin-align">
                        <ol>
                          <br />
                          {/* <li>
                            <b>
                              Exacerbation of MMA-related signs and symptoms,
                            </b>{" "}
                            which may include but are not limited to persistent vomiting,
                            anorexia, failure to feed/food intolerance, lethargy/decreased
                            activity, increased seizure activity, etc.
                          </li> */}
                          {/* <br /> */}
                          <li>
                            <b>Setting of acute medical care,</b> which may include visits
                            within inpatient/hospital, intensive care unit (ICU) or neonatal
                            ICU (NICU), emergency room (ER), or outpatient settings
                            <ul>
                              <li
                                className="important-note-item-circle"
                                style={{ marginLeft: 0 }}
                              >
                            Please use the "Other" settings option for MDEs beginning with encounters such as dietitian consultations, telehealth visits, etc. 
                            </li>

                              <li
                                className="important-note-item-circle"
                                style={{ marginLeft: 0 }}
                              >
                                If an MDE is determined to have occurred in multiple consecutive
                                care settings (e.g., patient transferred from ER to hospital),
                                the duration of the MDE will be defined from the start date of
                                the earliest care setting encounter to the discharge date of the
                                latest care setting encounter.
                              </li>
                            </ul>
                          </li>
                          <br />
                          <li>
                            <b>
                              Indications of biochemical abnormalities, anytime within 3 days before, during, or 3 days after (±3 days) the acute medical care encounter, as determined by
                              information contained within the patient’s medical record or
                              supported by laboratory testing, with specific focus on:
                            </b>
                            <ul>
                              <li
                                className="important-note-item-circle"
                                style={{ marginLeft: 0 }}
                              >
                                <u>Metabolic acidosis</u> (decreased pH with a high anion gap, including compensated metabolic acidosis [reduced bicarbonate, reduced base deficit, reduced PaCO2, or increased lactate, and a high anion gap]), or
                              </li>
                              <li
                                className="important-note-item-circle"
                                style={{ marginLeft: 0 }}
                              >
                                <u>Acute hyperammonemia</u> (increased ammonia)
                              </li>
                            </ul>
                          </li>
                        </ol>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SaveForm} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MDEInfoPage;
